import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import api from './api';

(window as any).Pusher = Pusher;

const REVERB_APP_KEY = process.env.REACT_APP_REVERB_APP_KEY || '';
const REVERB_HOST = process.env.REACT_APP_REVERB_HOST || 'localhost';
const REVERB_PORT = Number(process.env.REACT_APP_REVERB_PORT || 6001);
const REVERB_SCHEME = process.env.REACT_APP_REVERB_SCHEME || 'http';

export const boardChannelName = (boardId: number): string => `board.${boardId}`;

export const attachSocketIdHeader = (config: any, socketId: string | undefined): any => {
  if (socketId) {
    config.headers['X-Socket-Id'] = socketId;
  }
  return config;
};

let echoInstance: Echo<'reverb'> | null = null;

export const getEcho = (): Echo<'reverb'> => {
  if (echoInstance) {
    return echoInstance;
  }

  const echo = new Echo<'reverb'>({
    broadcaster: 'reverb',
    key: REVERB_APP_KEY,
    wsHost: REVERB_HOST,
    wsPort: REVERB_PORT,
    wssPort: REVERB_PORT,
    forceTLS: REVERB_SCHEME === 'https',
    enabledTransports: ['ws', 'wss'],
    // Réutilise l'instance Axios configurée pour Sanctum/XSRF.
    authorizer: (channel: any) => ({
      authorize: (socketId: string, callback: (error: boolean, data: any) => void) => {
        api
          .post('/broadcasting/auth', { socket_id: socketId, channel_name: channel.name })
          .then((response) => callback(false, response.data))
          .catch((error) => callback(true, error));
      },
    }),
  });

  echoInstance = echo;

  // Prépare X-Socket-Id pour les futurs toOthers().
  api.interceptors.request.use((config) => attachSocketIdHeader(config, echo.socketId()));

  return echo;
};

export const disconnectEcho = (): void => {
  echoInstance?.disconnect();
  echoInstance = null;
};
